module.exports = __webpack_public_path__ + "img/驳回.1e907982.svg";